import { AdviseMark, BuildMark, HireMark } from '../components/Motifs'
import { LANES, LANES_HEADING, LANES_LINE } from '../data/content'

const marks = {
  advise: AdviseMark,
  build: BuildMark,
  hire: HireMark,
} as const

export default function Lanes() {
  const [lead, ...rest] = LANES
  const LeadMark = marks[lead.id]

  return (
    <section className="sheet lanes">
      <div className="container">
        <h2>{LANES_HEADING}</h2>
        <div className="lanes-stack">
          <a className={`lane lane-${lead.id}`} href={lead.href}>
            <span className="lane-copy">
              <span className="lane-name">{lead.name}</span>
              <h3>{lead.title}</h3>
              <p>{lead.body}</p>
            </span>
            <LeadMark className="lane-mark" />
          </a>
          <div className="lane-pair">
            {rest.map((lane) => {
              const Glyph = marks[lane.id]
              return (
                <a key={lane.id} className={`lane lane-${lane.id}`} href={lane.href}>
                  <Glyph className="lane-mark" />
                  <span className="lane-copy">
                    <span className="lane-name">{lane.name}</span>
                    <h3>{lane.title}</h3>
                    <p>{lane.body}</p>
                  </span>
                </a>
              )
            })}
          </div>
        </div>
        <p className="lanes-line">{LANES_LINE}</p>
      </div>
    </section>
  )
}
